import { render, staticRenderFns } from "./ImageExpansion.vue?vue&type=template&id=64e412a5&scoped=true&lang=pug&"
import script from "./ImageExpansion.vue?vue&type=script&lang=ts&"
export * from "./ImageExpansion.vue?vue&type=script&lang=ts&"
import style0 from "./ImageExpansion.vue?vue&type=style&index=0&id=64e412a5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e412a5",
  null
  
)

export default component.exports